import { Tree, type TreeProps } from 'antd';

export interface ICheckableTreeProps
  extends Omit<
    TreeProps,
    'checkable' | 'selectable' | 'checkedKeys' | 'onCheck' | 'treeData'
  > {
  treeData: TreeProps['treeData'];
  /** Chiavi dei nodi spuntati (componente controllato). */
  value: string[];
  /** Notifica il chiamante ad ogni cambio di selezione. */
  onChange: (value: string[]) => void;
}

/**
 * Albero checkable presentazionale e controllato su Ant `Tree`: il chiamante
 * possiede la selezione (`value`) e reagisce a `onChange`. La cascata
 * padre↔figlio e lo stato half-checked sono gestiti da Ant `Tree`.
 *
 * È l'input "grafico" riutilizzabile: nessun legame con react-hook-form. Il
 * binding di form è fornito dal wrapper `CheckableTreeInput`.
 */
export function CheckableTree(props: ICheckableTreeProps) {
  const { treeData, value, onChange, ...treeProps } = props;

  return (
    <Tree
      checkable
      selectable={false}
      {...treeProps}
      checkedKeys={value}
      treeData={treeData}
      onCheck={checked => {
        // `checkStrictly` non è attivo → `checked` è un array di chiavi; le
        // nostre chiavi sono sempre stringhe.
        const keys = Array.isArray(checked) ? checked : checked.checked;
        onChange(keys.filter((key): key is string => typeof key === 'string'));
      }}
    />
  );
}
